/* global window */
(() => {
  const text = (value) => String(value || '').trim();
  const keyText = (value) => text(value).toLocaleLowerCase('nb-NO');
  const roundMoney = (value) => Math.round(Number(value || 0) * 100) / 100;
  const itemKey = (item = {}) => [
    text(item.kind),
    keyText(item.invoiceNumber),
    keyText(item.partyName),
    text(item.date),
  ].join(':');
  const originalAmount = (item = {}) => roundMoney(item.remainingAmount ?? item.outstanding ?? item.amountGross ?? item.amount);
  // Oppgjorene slas opp per post, og postene gas gjennom i loekker. Med et lineaert
  // sok ble det antall poster ganger antall oppgjor — som er lite pa et par bilag og
  // stort etter en import fra et annet regnskapssystem. Indeksen bygges en gang per
  // oppgjorsliste og henges pa selve listen, sa den forsvinner nar dataene byttes ut.
  const settlementIndexCache = new WeakMap();
  const settlementsByKey = (state = {}) => {
    const list = state.accountingImportOpenItemSettlements;
    if (!Array.isArray(list) || !list.length) return null;
    const cached = settlementIndexCache.get(list);
    if (cached) return cached;
    const index = new Map();
    // Forste treff vinner, slik det lineaere sokets `find` ogsa gjorde.
    list.forEach((entry) => {
      const key = text(entry?.itemKey);
      if (key && !index.has(key)) index.set(key, entry);
    });
    settlementIndexCache.set(list, index);
    return index;
  };
  const settlementFor = (state = {}, item = {}) => settlementsByKey(state)?.get(itemKey(item)) || null;
  const settledAmountOf = (settlement) => Math.max(0, Number(settlement?.settledAmount || 0));
  const remainingFromSettlement = (item, settlement) => {
    const original = originalAmount(item);
    if (original <= 0) return original;
    return roundMoney(Math.max(0, original - settledAmountOf(settlement)));
  };
  const remainingAmount = (state = {}, item = {}) => remainingFromSettlement(item, settlementFor(state, item));
  const decorate = (state = {}, item = {}) => {
    // Noekkelen bygges med locale-aware lowercase, som er en av de dyreste
    // strengoperasjonene som finnes. Den skal derfor bygges en gang per post her, ikke
    // en gang per oppslag.
    const key = itemKey(item);
    const settlement = settlementsByKey(state)?.get(key) || null;
    return {
      ...item,
      importItemKey: key,
      originalRemainingAmount: originalAmount(item),
      remainingAmount: remainingFromSettlement(item, settlement),
      importedSettlement: settlement,
      status: settlement?.status || item.status || 'open',
    };
  };
  window.PlummeAccountingImportOpenItems = { itemKey, originalAmount, settlementFor, remainingAmount, decorate };
})();
